import { useTranslation } from 'react-i18next'
import ConfirmModal from '../confirm-modal/index.jsx'

type Props = {
  visible: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteSponsorModal = ({ visible, onClose, onConfirm }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <ConfirmModal
        visible={visible}
        onClose={onClose}
        onConfirm={onConfirm}
        title={t('Remove Sponsored Listing?')}
        subTitle={t(
          'This will prevent your listing from being sponsored and will not be displayed at the top of the search results.'
        )}
        confirmText={t('common.continue', 'Continue')}
      />
    </>
  )
}

export default DeleteSponsorModal
